module.exports = __webpack_public_path__ + "static/media/marketing-hub.ae316a16.svg";